import { gql } from "@apollo/client";
import Avatar from "atoms/Avatar";
import { getStatColor } from "helpers/colors";
import { ONSEN_ENV } from "helpers/environment";
import REACTION_TYPES from "helpers/REACTION_TYPES";
import React from "react";

export const EventMarkerFragment = gql`
  fragment EventMarkerFragment on EventView {
    humanName
    singleCharacter
    reactionType
    made
  }
`;

export default function EventMarker({ eventView, size = 16, active = false, inverse = false, ...others }) {
  let eventColor = getStatColor(eventView?.humanName);
  let eventChar = eventView?.singleCharacter;
  let imgSrc = null;

  if (eventView?.reactionType) {
    imgSrc = REACTION_TYPES.find((r) => r.name === eventView?.reactionType)?.imgSrc || REACTION_TYPES[0]?.imgSrc;
    if (ONSEN_ENV === "test" && !imgSrc) throw new Error(`Unexpected reactionType: ${eventView?.reactionType}`);
  }

  return (
    <Avatar
      inverse={inverse}
      active={active}
      size={size}
      text={eventChar}
      color={eventColor}
      imgSrc={imgSrc}
      {...others}
    />
  );
}
